import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { ClipboardService } from '../../clipboard.service'
import * as models from '../../models'

// TODO: In the ideal world we can have the paste action be the source for any
// create or other actions that  gets emitted on paste. The current `callback`
// approach does not allow that.

/**
 * TODO:
 */
export const pasteSelected = store.effects.create(
  (feature: ClipboardService['_feature']) =>
    // FIXME: evaluate if its possible to utilize 'relay' here.
    feature.actions.pasteSelected.request.observe().pipe(
      rxjsUtils.latestFrom(
        action => ({
          action: rxjs.of(action),
          selectedItems: feature.selectors.selectedItems.asObservable,
          paster: feature.selectors.paster.asObservable,
        }),
        (
          data,
        ): data is typeof data & {
          paster: NonNullable<typeof data.paster>
        } => data.paster !== undefined,
      ),
      rxjs.switchMap(({ action, paster, selectedItems }) => {
        /** All selected {@link models.Item items} that we want start pasting process for  */
        const items = selectedItems.map(identifiedItem => identifiedItem.item)

        const pasteResult = paster.apply(items)

        const successAction = feature.actions.pasteSelected.success
          .from(action)
          .create()

        // If nothing is returned from callback, just dispatch success action
        if (!pasteResult) {
          return rxjs.of(successAction)
        }

        if (pasteResult instanceof Promise) {
          // If the result is a Promise, we just need to wait until the
          // Promise completes. We don't actually care about Promise's return
          // value. After Promise is finished, dispatch
          // success action
          return rxjs.from(pasteResult).pipe(rxjs.map(() => successAction))
        }

        // Dispatch new actions returned from the callback together with
        // success action after callback result is received
        return rxjs.merge(
          rxjs.from(pasteResult.actions),
          pasteResult.result$.pipe(rxjs.map(() => successAction)),
        )
      }),
    ),
)
